import React, { Fragment, useState } from 'react';
import { translate } from '../../Services/translation';
import { post } from '../../Services/http';
import ReCAPTCHA from "react-google-recaptcha";
const LoginWithCode = (props) => {
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [codeSent, setCodeSent] = useState(false);
  const [errorMessage, seterrorMessage] = useState('');
  const [showStatus, setShowStatus] = useState(false);
  const [showRecaptcha, setShowRecaptcha] = useState(false);

  const sendCode = () => {
    const sendSmsCodeRequest = {
      phoneNumber: phone,
    };
    post('api/loginwithcode/sendCode', sendSmsCodeRequest)
      .then(() => {
        seterrorMessage('');
        setCodeSent(true);
        setShowStatus(true);
      })
      .catch((error) => {
        if (error.response.status === 500) {
          seterrorMessage(translate('coptikk.login.generalerror'));
        }
      });
  };
  const validateCodeAndLogin = () => {
    const loginWithCodeRequest = {
      phoneNumber: phone,
      code: code,
    };
    seterrorMessage('');
    setShowStatus(false);
    post('api/loginwithcode', loginWithCodeRequest)
      .then(() => {
        seterrorMessage('');
        setShowStatus(false);
        const redirectLink = props.RedirectLink ? props.RedirectLink : '/';
        window.location.href = redirectLink;
      })
      .catch((error) => {
        setShowStatus(false);
        if (error.response.status === 500) {
          seterrorMessage(translate('coptikk.login.generalerror'));
        }
        if (error.response.status === 400 || error.response.status === 404) {
          seterrorMessage(translate('coptikk.login.authenticationfailed'));
        }
      });
  };

  const validateRecaptchaToken = async (recaptchaToken) => {
    try {
      if(recaptchaToken === null) return;
      await fetch("api/loginwithcode/validateRecaptchaToken", {
        method: "POST",
        body: JSON.stringify(recaptchaToken),
        headers: {
          "Content-Type": "application/json",
        }
      }).then((res) => {
        const isRecaptchaTokenValid = res.ok;
        if (isRecaptchaTokenValid) {
          validatePhoneAndSendCode();
          setTimeout(() => {
            setShowRecaptcha(false);
          }, 2000)
        }
      })
    } catch (error) {
      console.error(error.message)
    }
  }

  const checkFormatAndSetPhone = (value) => {
    value = value.replace(/[^0-9]/g, '');
    setPhone(value);
  };

  const validatePhoneAndSendCode = () => {
    setShowStatus(false);
    const regexNorway = /^\d{8}$/;    
    if (regexNorway.test(phone)) {
      sendCode();
    } else {
      seterrorMessage(translate('coptikk.login.invalidphonenumber'));
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (codeSent) {
        validateCodeAndLogin();
      } else {
        validatePhoneAndSendCode();
      }
    }
  };
  return (
    <Fragment>
      
      {errorMessage && !showStatus && (
        <div className="codelogin__error">{errorMessage}</div>
      )}
      <div>
        <label>{translate('coptikk.login.phone')}</label>
        <input
          type="text"
          value={phone}
          placeholder="xxxxxxxx"
          onChange={(e) => checkFormatAndSetPhone(e.target.value)}
          onKeyPress={handleKeyPress}
        ></input>
      </div>
      <div>
        {showStatus && (
          <div className="logincodesent">
            <strong>
              {translate('login.general.successtext').replace('{phone}', phone)}
            </strong>
          </div>
        )}
      </div>
      {codeSent && (
        <div>
          <label>{translate('coptikk.login.code')}</label>
          <input
            type="text"
            value={code}
            placeholder="xxxxxx"
            onChange={(e) => setCode(e.target.value)}
            onKeyPress={handleKeyPress}
          ></input>
        </div>
      )}
      
      {!codeSent && (
        <div>
          <button onClick={() => setShowRecaptcha(true)}>
            {translate('coptikk.login.sendcode')}
          </button>
        </div>
      )}

      {showRecaptcha && 
        <ReCAPTCHA
        sitekey={props.RecaptchaSiteKey}
        onChange={validateRecaptchaToken}
        />
      }

      {codeSent && (
        <div>
          <button onClick={() => validateCodeAndLogin()}>
            {translate('coptikk.login.logintext')}
          </button>
        </div>
      )}
      <div className="codelogin__help">
        <a href={props.HelpLink}>{translate('coptikk.login.helptext')}</a>
      </div>
    </Fragment>
  );
};

export default LoginWithCode;
